import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { MainLayout } from 'components/Layout/MainLayout';
import { useAppDispatch, useAppSelector } from 'store';
import {
  loadCurrentResidentsItem,
  saveCurrentResidentsItem,
  saveCurrentResidentsItemDraft,
} from 'store/slices/currentResidents/actions';
import { CurrentResidentsItem } from 'store/slices/currentResidents/interfaces';
import { DeepPartial } from 'types/utils';
import { LangEnum } from 'constants/lang';

import { Form } from './components/Form';
import { mapValuesToForm } from './components/Form/formUtils';

export const AddTranslation = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { item } = useAppSelector(state => state.currentResidents);
  const isCorrectItem = item?.id === Number(id);

  React.useEffect(() => {
    dispatch(loadCurrentResidentsItem(id));
  }, [id]);

  const onSubmit = (values: CurrentResidentsItem) => {
    setIsLoading(true);
    dispatch(saveCurrentResidentsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Действующий резидент успешно добавлен',
        });
        navigate('/currentResidents');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveAsDraft = (values: DeepPartial<CurrentResidentsItem>) => {
    setIsLoading(true);
    dispatch(saveCurrentResidentsItemDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Действующий резидентуспешно добавлен',
        });
        navigate('/currentResidents');
      })
      .catch(() => setIsLoading(false));
  };

  const preparedValues = {
    ...item,
    lang: LangEnum.en,
  };

  return (
    <MainLayout pageTitle='Создание'>
      {isCorrectItem && (
        <Form
          onSubmit={onSubmit}
          isDraft
          isLoading={isLoading}
          defaultValues={mapValuesToForm(preparedValues)}
          onSaveAsDraft={onSaveAsDraft}
        />
      )}
    </MainLayout>
  );
};
